import styled from 'styled-components/macro'
import { mobile } from '../theme'
import { Link, useLocation } from 'react-router-dom'

const Breadcrumbs = styled.ul`
  list-style-type: none;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  padding-bottom: calc(${p => p.theme.spacing} * 2);
  width: 100%;

  ${mobile`
    padding-bottom: 16px;
  `}

  > li > a {
    transition: background-color 100ms ease, color 100ms ease;
    display: block;
    user-select: none;
    position: relative;
    text-decoration: none;
    background-color: #f2f2f2;
    color: rgba(${p => p.theme.color.text.primary}, 1);
    padding: 0 5px 0 14px;
    line-height: 24px;
    height: 24px;
  }

  > li > a:hover,
  > li > a:focus {
    background-color: rgba(${p => p.theme.color.primary}, 1);
    color: rgba(${p => p.theme.color.light}, 1);
    outline: none;
  }

  > li > a:hover::after,
  > li > a:focus::after {
    border-left-color: rgba(${p => p.theme.color.primary}, 1);
  }

  > li + li {
    margin-left: 4px;
  }

  > li > a::before,
  > li > a::after {
    transition: border-left-color 100ms ease;
    content: '';
    position: absolute;
    top: 0;
    right: -8px;
    width: 0;
    border-left: 8px solid #f2f2f2;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    z-index: 1;
  }

  > li > a::before {
    border-left-color: rgba(${p => p.theme.color.light}, 1);
    z-index: initial;
    left: 0;
  }

  > li:first-child > a::before,
  > li:last-child > a::after {
    content: none;
  }

  > li:first-child > a {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    padding-left: 10px;
  }

  > li:last-child > a {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    padding-right: 10px;
  }
`

const getDisplayName = path => {
  switch (path) {
    case 'history':
      return 'Historie';
    case 'book':
      return 'Buch';
    case 'texts':
      return 'Texte';
    case 'podcasts':
      return 'Podcasts';
    case 'media':
      return 'Medien';
    case 'cooperation':
      return 'Partner';
    case 'survey':
      return 'Fragebogen';
    case 'disclaimer':
      return 'Disclaimer';
    case 'contact':
      return 'Kontakt';
    default:
      return 'Unbekannt';
  }
}

export default () => {
  const location = useLocation()

  return (
    <Breadcrumbs>
      <li key={0}><Link to='/'>Startseite</Link></li>
      {
        location.pathname
          .split('/')
          .filter(a => a !== '')
          .map((path, index, array) => (
            <li key={++index}>
              <Link to={array
                .slice(0, ++index)
                .reduce((a, b) => a + '/' + b, '')
              }>{getDisplayName(path)}</Link>
            </li>
          ))
      }
    </Breadcrumbs>
  )
}
